import { render } from "./HeroHeader.vue?vue&type=template&id=6aeb0ae4"
import script from "./HeroHeader.vue?vue&type=script&lang=js"
export * from "./HeroHeader.vue?vue&type=script&lang=js"

import "./HeroHeader.vue?vue&type=style&index=0&id=6aeb0ae4&lang=css"
script.render = render

export default script